module.exports = __webpack_public_path__ + "static/dave-and-dad-893a05783f9a5fc2c7afe767601b4162.jpg";